import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPercentage = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 20'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='percentage_svg__a'
      width={14}
      height={16}
      x={3}
      y={2}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill={props.color}
        d='M14.333 2.834a.833.833 0 1 1 1.333 1l-10 13.333a.833.833 0 1 1-1.333-1zM7.5 5.417a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.666 0a2.917 2.917 0 1 1-5.833 0 2.917 2.917 0 0 1 5.833 0M15 14.584a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0m1.666 0a2.917 2.917 0 1 1-5.833 0 2.917 2.917 0 0 1 5.833 0'
      />
    </mask>
    <g mask='url(#percentage_svg__a)'>
      <path fill={props.color} d='M0 0h20v20H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgPercentage)
export default ForwardRef
